export default __webpack_public_path__ + "3a8a70c70538bbb2c056ee47fa087211.jpg";